var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter-clear",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 66",
    style: {
      enableBackground: "new 0 0 75 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9,47.6c0-7.4,4.2-13.8,10.3-17.1L73.8,5.1c2.1-2,0.5-5.1-2.6-5.1H3.7c-3,0-4.6,3.2-2.6,5.1l27.4,26.1 c0.8,0.8,1.2,1.7,1.2,2.8V64c0,1.8,2.5,2.7,4,1.5l6.7-6.8C38.2,55.6,36.9,51.8,36.9,47.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6,29.2c-10.2,0-18.4,8.3-18.4,18.4s8.3,18.4,18.4,18.4S75,57.8,75,47.6S66.7,29.2,56.6,29.2z M61.7,58.3l-5-5l-5.2,5.2 L46,53l5.2-5.2l-5-5l5.5-5.5l5,5l4.8-4.8l5.5,5.5l-4.8,4.8l5,5L61.7,58.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClear);
export default __webpack_public_path__ + "static/media/filter-clear.695d6625848266cdf8b2a29919dfec50.svg";
export { ForwardRef as ReactComponent };